import { useQuery } from "@tanstack/react-query";
import useRevenue from "../utils/useRevenue";

export default function useStoresData({ enabled }) {
  const { getStores } = useRevenue();

  const { data, isLoading, error } = useQuery({
    queryKey: ["stores"],
    queryFn: getStores,
    enabled,
  });

  const formattedData = data?.data.lojas
    ? [
        { label: "Todos", value: "all" },
        ...data.data.lojas.map((store) => ({
          label: store,
          value: store,
        })),
      ]
    : [];

  return { data: formattedData, isLoading, error };
}
